<template>
    <veui-select class="search-select"
        v-on="$listeners"
        :filter="realFilter"
        :overlayClass="realOverlayClass"
        v-bind="$props">
        <template slot="before">
            <slot name="before"><veui-searchbox class="filter" ui="tiny" v-model="keyword"></veui-searchbox></slot>
        </template>
    </veui-select>
</template>

<script>
import {Select, Searchbox} from 'veui';
import {includes} from 'lodash';

export default {
    name: 'search-select',
    components: {
        'veui-select': Select,
        'veui-searchbox': Searchbox
    },
    mixins: Select.mixins,
    props: Select.props,
    data() {
        return {
            keyword: ''
        };
    },
    computed: {
        realFilter() {
            return this.filter || this.defaultFilter;
        },
        realOverlayClass() {
            let clz = this.overlayClass || '';
            return `${clz} search-select-overlay`.trim();
        }
    },
    methods: {
        defaultFilter({label}) {
            return includes(label, this.keyword);
        }
    },
    model: Select.model
};
</script>

<style lang="less">
.search-select-overlay {
    min-width: 210px;
    .veui-searchbox {
        position: absolute;
        top: 3px;
        left: 0;
        right: 0;
        width: auto;
    }
    .veui-option-group {
        margin-top: 26px;
    }
}
</style>
